<template>
    <header>
        <div class="header-first ">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-6 col-lg-6 ">
                        <a href="https://www.gov.co/home/" title="Ir a gov.co" target="_blank" accesskey="U"
                            tabindex="0">
                            <img class="img-header" src="https://cdn.www.gov.co/assets/images/logo.svg" height="30"
                                width="140" alt="GOV.CO | Gobierno de Colombia">
                        </a>
                    </div>
                    <div class="col-6 col-lg-6 text">
                        <a href="https://www.gov.co/home/" title="Ir a gov.vo" target="_blank" accesskey="U"
                            tabindex="0">Ir a Gov.co</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="header-second">
            <div class="container">
                <div class="row ">
                    <div class="col-3 col-lg-3 left">
                        <a href="https://ansv.gov.co/" title="Logo ANSV" target="_blank" accesskey="U" tabindex="0">
                            <img class="img-header" src="@/assets/logoAnsv.png" height="30" width="140" alt="ANSV ">
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="header-third">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-9 col-lg-9">
                        <h1 v-if="user.state.textoHeader == 1">Ingreso</h1>
                        <h1 v-if="user.state.textoHeader == 2">Bienvenido</h1>
                        <h1 v-if="user.state.textoHeader == 3">Examen teórico</h1>
                    </div>

                    <div class="col-12 col-3 col-lg-3">
                        <h4 v-if="user.state.textoHeader == 2 || user.state.textoHeader == 3">{{ user.state.name }}
                                {{user.state.primerApellido}}
                             <a data-bs-toggle="modal" title="Exit" data-bs-target="#modalCerrarSesion">
                                <img class="icon" src="@/assets/ico-salir@2x.png" style="cursor: pointer" width="23px">
                            </a></h4>
                        <p v-if="user.state.textoHeader == 1"></p>
                        <p v-if="user.state.textoHeader == 2 || user.state.textoHeader == 3">
                            Aspirante
                        </p>
                    </div>
                </div>
                <div class="modal fade" id="modalCerrarSesion" tabindex="-1" aria-labelledby="modalCerrarSesion"
                    aria-hidden="true" data-bs-backdrop="static">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="modalCerrarSesion">Cerrar sesión</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                ¿Está seguro que desea cerrar la sesión?
                            </div>
                            <div class="modal-footer">
                                <!-- <button type="button" class="btn btn-secondary" >Close</button> -->
                                <a type="button" data-bs-dismiss="modal" aria-label="Close"
                                    class="ingresar btn btn-primary">
                                    Cancelar
                                </a>
                                <a type="button" href="/" @click="$store.commit('cerrarSesion')"
                                    class="ingresar btn btn-primary">
                                    Salir
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { useStore } from 'vuex'
export default {
    name: 'HeaderPage',
    setup() {
        const user = useStore();
        return { user }
    },
}
</script>

<style lang="scss" >
// @import '@/fonts/fonts.scss';
@import '@/components/Header/Header.scss';

.modal-body {
    color: black;
}
</style>